var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFlagDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 28 20",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0 6.667h28v6.667h-28z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "145%",
    width: "110.7%",
    x: "-5.4%",
    y: "-22.5%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m0 13.333h28v6.667h-28z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    height: "145%",
    width: "110.7%",
    x: "-5.4%",
    y: "-22.5%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 20,
    rx: 3,
    width: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h28v6.667h-28z",
    fill: "#262626",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#f01515",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffd521",
    xlinkHref: "#c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlagDe);
export default __webpack_public_path__ + "static/media/ic_flag_de.0d18ed905cfed57e616330551e1b3b41.svg";
export { ForwardRef as ReactComponent };